import ClickAndCollectViewTabs from './ClickAndCollectViewTabs';

export default ClickAndCollectViewTabs;
